import { sellByWeightFromUnit } from '@shared/quantity';
import type { UnitOfMeasure } from '@shared/quantity';
import {
  computeLineTotal as sharedComputeLineTotal,
  formatUnitLabel as sharedFormatUnitLabel,
  productRequiresHourInput as sharedRequiresHour,
  productRequiresQuantityInput as sharedRequiresQuantity,
  productRequiresWeightInput as sharedRequiresWeight,
} from '@shared/quantity';

export type { UnitOfMeasure };

export type ProductVariant = {
  id: string;
  organizationId: string;
  productId: string;
  sku?: string | null;
  barcode?: string | null;
  nameSuffix?: string | null;
  attributes: Record<string, string>;
  price?: number | null;
  imageUrl?: string | null;
  isActive: boolean;
};

export type CatalogProductExtensions = {
  unitOfMeasure: UnitOfMeasure;
  /** @deprecated Derived from unitOfMeasure (kg/g). Kept for cart/sync shape. */
  sellByWeight: boolean;
  parentProductId?: string | null;
  variants?: ProductVariant[];
};

export function productRequiresWeightInput(product: Pick<CatalogProductExtensions, 'unitOfMeasure'>): boolean {
  return sharedRequiresWeight(product);
}

export function productRequiresHourInput(product: Pick<CatalogProductExtensions, 'unitOfMeasure'>): boolean {
  return sharedRequiresHour(product);
}

export function productRequiresQuantityInput(product: Pick<CatalogProductExtensions, 'unitOfMeasure'>): boolean {
  return sharedRequiresQuantity(product);
}

export const formatUnitLabel = sharedFormatUnitLabel;

export function computeLineTotal(price: number, quantity: number, uom: UnitOfMeasure): number {
  return sharedComputeLineTotal(price, quantity, uom);
}

export { sellByWeightFromUnit };
